/** @format */

import {GetAiReportsQueryPage} from 'pages/Home/Main/Project/components/AiModule/graphql/__generated__';

import {TanStackTableData} from 'components/Table/core/types';


type AiReportsArray = NonNullable<
  NonNullable<GetAiReportsQueryPage['currentUser']>['currentCompany']
>['marvinAiReports'];

export const transformAiReportsToTableData = (
  aiReports: AiReportsArray | undefined,
): TanStackTableData[] => {
  if (!aiReports) {
    return [];
  }

  return aiReports.map(report => ({
    id: report.marvinReportId || '',
    reportDate: report.reportDate || '',
    status: report.status || '',
    companyName: report.companyName || '',
    hasFeedback: report.hasFeedback || false,
    source: report.source,
  }));
};
